const nextRoutes = require('next-routes');

const routes = nextRoutes();

module.exports = routes
  .add('preview-onboarding', '/preview/onboarding/:token')
  .add('preview', '/preview/:token')
  .add('login', '/login')
  .add('signup', '/signup')
  .add('signin', '/signin')
  .add('product', '/l/:marketName/:hotelName')
  .add('gift-confirmation', '/purchase/gift-card/:giftCardId')
  .add('pass-confirmation', '/purchase/subscription')
  .add('hotel-reviews', '/hotel-reviews/:marketName?/:hotelName?/:hotelId?')
  .add('search', '/s/:marketName?/:category')
  .add('password-recovery', '/password-recovery/:resetToken')
  .add('checkout-hotel', '/checkout/:marketName/:hotelName-:productName/:productId')
  .add('checkout-gift', '/checkout/gift-card')
  .add('checkout-pass', '/checkout/subscription-:planName')
  .add('booking', '/purchase/:marketName/:hotelName-:productName/:productId/:id')
  .add('product-redirect', '/:marketName/:city/:hotelName/:productName/:productId');
